import { IconName, IconProps } from './types';
import {
  EditIcon,
  ErrorIcon,
  BackIcon,
  CloseIcon,
  Search,
  CheckIcon,
  InfoIcon,
  WarningIcon,
  FilledWarningIcon,
  DownIcon,
  DownloadIcon,
} from './icons';

type IconMap = {
  [key in IconName]: (props: IconProps) => JSX.Element;
};

const iconMap: IconMap = {
  back: BackIcon,
  info: InfoIcon,
  edit: EditIcon,
  close: CloseIcon,
  search: Search,
  check: CheckIcon,
  error: ErrorIcon,
  warning: WarningIcon,
  filledWarning: FilledWarningIcon,
  down: DownIcon,
  download: DownloadIcon,
};

export const getIcon = (name: IconName): ((props: IconProps) => JSX.Element) => {
  return iconMap[name];
};
